import { render } from "./Emotions-1.vue?vue&type=template&id=30cba28b"
import script from "./Emotions-1.vue?vue&type=script&lang=js"
export * from "./Emotions-1.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__